/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Validation_Error_Modal_Subtitle_OneInputs */

const en_validation_error_modal_subtitle_one = /** @type {(inputs: Validation_Error_Modal_Subtitle_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`There is 1 validation error in the data grid.`)
};

const nl_validation_error_modal_subtitle_one = /** @type {(inputs: Validation_Error_Modal_Subtitle_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Er is 1 validatiefout in het gegevensraster.`)
};

/**
* | output |
* | --- |
* | "There is 1 validation error in the data grid." |
*
* @param {Validation_Error_Modal_Subtitle_OneInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const validation_error_modal_subtitle_one = /** @type {((inputs?: Validation_Error_Modal_Subtitle_OneInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Validation_Error_Modal_Subtitle_OneInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_validation_error_modal_subtitle_one(inputs)
	return en_validation_error_modal_subtitle_one(inputs)
});